import { useQuery } from '@tanstack/react-query';
import { settingsService } from '@/services';
import { queryKeys } from '@/services/query-keys';

// Global settings query
export const useSettingsQueries = () => {
  return useQuery({
    queryKey: queryKeys.settings.global,
    queryFn: () => settingsService.getGlobalSettings(),
    staleTime: 10 * 60 * 1000, // 10 minutes
    retry: 1,
    enabled: true,
  });
};

// Private settings query
export const usePrivateSettings = () => {
  return useQuery({
    queryKey: queryKeys.settings.all, // Using settings.all or add private to queryKeys
    queryFn: () => settingsService.getPrivateSettings(),
    staleTime: 30 * 60 * 1000, // 30 minutes
    retry: 1,
  });
};
